import DuperbrowsePageWrapper from './DuperbrowsePageWrapper';
import DuperbrowsePageWrapperContainer from './DuperbrowsePageWrapper.container';
export default DuperbrowsePageWrapperContainer(DuperbrowsePageWrapper);

//# sourceMappingURL=index.js.map